/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement } from 'react';
import { useTable, Column } from 'react-table';

import {
  Table as ChakraTable,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Flex,
  useColorModeValue,
  Box,
  Text,
} from '@chakra-ui/react';

export interface ITableDataProps {
  [key: string]: string | number | ReactElement | null;
}

interface ITableProps {
  columns: Array<Column<ITableDataProps>>;
  data: Array<ITableDataProps>;
  action?: any;
  cursor?: string;
}

const ScrollTable: React.FC<ITableProps> = ({
  columns,
  data,
  action,
  cursor,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable({
      columns,
      data,
    });

  const color = useColorModeValue('gray.700', 'white');
  const bg = useColorModeValue('white', 'gray.800');
  const detailsBg = useColorModeValue('gray.100', 'gray.900');

  return (
    <Flex direction="column" h="100%" w="100%">
      <Box overflowY="auto" h="100%">
        <ChakraTable variant="simple" size="sm" {...getTableProps()}>
          <Thead h="6vh" bg={bg}>
            {headerGroups.map(headerGroup => (
              <Tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <Th
                    position="sticky"
                    top={0}
                    zIndex={1}
                    bg={bg}
                    textAlign={column.id === 'actions' ? 'center' : 'left'}
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {rows.map((row: any) => {
              prepareRow(row);
              return (
                <Tr
                  {...row.getRowProps()}
                  _hover={{ backgroundColor: detailsBg }}
                  cursor={cursor ?? 'pointer'}
                >
                  {row.cells.map((cell: any) => (
                    <Td
                      p="1rem"
                      color={color}
                      {...cell.getCellProps()}
                      onClick={() => action?.(row?.original)}
                    >
                      {cell.render('Cell')}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </ChakraTable>
        {data?.length === 0 && (
          <Flex h="100px" w="100%" align="center" justify="center">
            <Text fontWeight="medium" fontSize="2xl">
              Sem Dados
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
  );
};

export default ScrollTable;
